module.exports = __webpack_public_path__ + "static/img/3s-info-b2.29a17fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-info-b2.png
// module id = mLsT
// module chunks = 0